<template>
  <modal-layout :openModal="openModal">
    <div class="bg-white rounded-lg relative w-3/4 md:w-1/3">
      <change-name-modal
        :openPopup="changeNamePopup"
        :callback="() => (changeNamePopup = false)"
        :memberId="memberData._id"
        :memberProviderId="memberDetails.providerId"
        :previousName="firstName"
        :previousEmail="
          memberDetails.FirstNameInfo && memberDetails.FirstNameInfo.memberEmail
            ? memberDetails.FirstNameInfo.memberEmail
            : memberDetails.userEmail || ''
        "
        :previousFullName="
          memberDetails.FirstNameInfo && memberDetails.FirstNameInfo.memberName
            ? memberDetails.FirstNameInfo.memberName
            : memberDetails.userName
        "
        :previousNotes="
          memberDetails.FirstNameInfo && memberDetails.FirstNameInfo.memberNotes
            ? memberDetails.FirstNameInfo.memberNotes
            : ''
        "
        :fetchStudentList="handleGetMemberDetails"
        :changeNameType="'SINGLE'"
        :enrolled="[]"
        :enrolledStudents="[]"
      />
      <spinner :loading="loader" />
      <div
        :class="[
          ' flex-col items-start p-4',
          changeNamePopup ? ' hidden' : 'flex',
        ]"
      >
        <div class="flex items-center w-full">
          <div class="text-gray-900 font-bold text-lg">Member info</div>
          <div
            class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
            @click="closeModalCallback"
          >
            <closeIcon />
          </div>
        </div>
        <div class="my-3">
          <section class="flex">
            <div class="whitespace-nowrap text-gray-900 flex mr-5">
              <template
                >
                {{ memberDetails.FirstNameInfo && memberDetails.FirstNameInfo.memberName
            ? memberDetails.FirstNameInfo.memberName
            : memberDetails.userName }}
              </template>
              <a
                class="whitespace-nowrap text-gray-900 ml-1"
                target="_blank"
                :href="'https://twitter.com/' + memberDetails.acctUsername"
              >
                ({{
                  memberDetails.acctUsername ? memberDetails.acctUsername : `-`
                }})
              </a>
              </div>
          </section>
          <section class="text-black font-bold border-none flex mt-4">
              <span class="mr-5 text-gray-600">Added:</span>
              {{
                memberDetails.createdAt
                  ? showDateTime(memberDetails.createdAt)
                  : `-`
              }}
          </section>
          <section class="text-black font-bold border-none flex mt-4">

              <span class="mr-5 text-gray-600">First name:</span>
              {{ firstName }}
            <font-awesome-icon
              class="reaction text-gray-600 ml-5"
              size="lg"
              :icon="['far', 'edit']"
              @click="() => (changeNamePopup = true)"
            />
          </section>
          <section class="text-black font-bold border-none flex mt-4">
              <span class="mr-5 text-gray-600">Email:</span>
              {{ memberDetails.FirstNameInfo && memberDetails.FirstNameInfo.memberEmail
            ? memberDetails.FirstNameInfo.memberEmail
            : memberDetails.userEmail || '-' }}
          </section>
          <section class="text-black font-bold border-none flex mt-4">
              <span class="mr-5 text-gray-600">Bio:</span>
              {{ memberDetails.bio || '-' }}
          </section>
          <section class="text-black font-bold border-none flex mt-4">
              <span class="mr-5 text-gray-600">Notes:</span>
               {{ memberDetails.FirstNameInfo && memberDetails.FirstNameInfo.memberNotes ? memberDetails.FirstNameInfo.memberNotes : '-'  }}
          </section>
          <section class="text-black font-bold border-none flex mt-4">
              <span class="mr-5 text-gray-600">Last Commented:</span>
              {{ showDateTime(lastCommented) || '-' }}
          </section>
          <section class="text-black font-bold border-none flex mt-4">
               <span class="mr-5 text-gray-600">Reminder:</span>
                   <a
                   v-for="(data) in reminderType"
                   :key="data.value"
                   :class="['text-base font-medium outline-none cursor-pointer hover:text-blue-600 mr-1',memberDetails.userSubmissions && memberDetails.userSubmissions.reminder && memberDetails.userSubmissions.reminder.reminderDuration === data.value ? 'text-blue-600 font-bold' : 'text-gray-700']"
                  @click="()=>{
                    reminderDuration=data.value;
                    setReminder();
                    }">
                    {{ data.label}},
                    </a>
                  <a v-if="memberDetails.userSubmissions && memberDetails.userSubmissions.reminder" class=" text-red-600 cursor-pointer" @click="()=>clearReminder()">Clear</a>
          </section>
          <section class="flex flex-wrap mt-4">
            <span class="mr-5 text-gray-600 font-bold">Segments:</span>
            <p
              v-for="(item, index) in mySegments"
              :key="index"
              class="
                hover:text-blue-700 hover:underline
                cursor-pointer
                mb-1
                mr-2
              "
              @click="handleChangeCourse(item.courseId)"
            >
              {{ item.title }},
            </p>
          </section>
        </div>
        <hr class="w-full my-3" />
        <section class="w-full flex justify-center">
          <div class="mr-5">
            <button
              class="btn btn-primary btn-outline"
              @click="closeModalCallback"
            >
              ok
            </button>
          </div>
          <div class="">
            <button
              class="
                btn btn-outline
                border border-red-600
                text-red-600
                bg-white
                hover:bg-gray-100
              "
              @click="handleDeleteModal"
            >
              Remove
            </button>
          </div>
        </section>
      </div>
    </div>
  </modal-layout>
</template>

<script>
import moment from 'moment';
import closeIcon from '../icons/closeIcon.vue';
import utils from '@/services/utils';
import axiosApi from '../../services/inteceptor';
import spinner from '@/components/spinner.vue';
import ModalLayout from '../../layouts/ModalLayout.vue';
import ChangeNameModal from '../Audience/ChangeNameModal.vue';
import reminderType from '@/utils/Constants/reminderType.constants';

const API_USER_INFO = `${utils.svcUrl()}user-info`;

export default {
  name: 'MemberDetailsModal',
  components: {
    closeIcon,
    spinner,
    ModalLayout,
    ChangeNameModal,
  },
  props: [
    'openModal',
    'closeModalCallback',
    'memberData',
    'courseId',
    'handleDeleteModal',
  ],
  data() {
    return {
      pipeline_name: '',
      memberDetails: {},
      loader: false,
      deleteModal: false,
      mySegments: [],
      changeNamePopup: false,
      reminderType,
    };
  },
  mounted() {
    this.handleGetMemberDetails();
  },
  computed: {
    lastCommented() {
      return this.memberDetails?.usersmentions?.createdAt;
    },
    firstName() {
      return (
        this.memberDetails?.FirstNameInfo?.memberFirstName ||
        this.memberDetails?.userName?.split(' ')[0]
      );
    },
  },
  methods: {
    async handleAddNewPipeline() {
      try {
        this.$store.commit('NEW_PIPELINE_POPUP', false);
        await this.$store.dispatch('createPipeline', {
          pipeline_name: this.pipeline_name,
        });
        this.$store.dispatch('fetchPipelineData');
        this.pipeline_name = '';
      } catch (error) {
        utils.setStatusMsg(this, error?.message || 'something went wrong');
      }
    },
    async handleGetMemberDetails() {
      try {
        this.loader = true;
        // console.log(this.memberData);
        const response = await axiosApi.get(
          `${API_USER_INFO}/info?userId=${this.memberData?._id}&courseId=${this.courseId}`,
        );
        console.log(response?.data);
        this.memberDetails = response?.data?.data;
        // this.loader = false;
        this.handleGetSegment();
      } catch (error) {
        utils.setStatusMsg(this, error?.message || 'something went wrong');
        this.loader = false;
      }
    },
    showDateTime(DateTime) {
      return DateTime ? moment(DateTime).fromNow() : 'No activity';
    },
    async handleGetSegment() {
      try {
        const response = await this.$store.dispatch('fetchMemberSegmentList', {
          userId: this.memberData?._id,
        });
        this.mySegments = response.data.data;
        this.loader = false;
      } catch (err) {
        this.loader = false;
        console.log('segment list of user err', err);
        if (err?.response) {
          utils.setStatusMsg(this, err.response.data.message);
        }
      }
    },
    handleChangeCourse(id) {
      this.$router.push(`/admin/audience?courseId=${id}`);
    },
    async setReminder() {
      try {
        const payload = {
          memberId: this.memberData?._id,
          reminderDuration: this.reminderDuration,
          courseId: this.courseId,
        };
        console.log(payload);
        this.$store.commit('toggleLoading', true);
        const response = await this.$store.dispatch('setReminder', payload);
        this.handleGetMemberDetails();
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response?.message);
      } catch (error) {
        utils.setStatusMsg(this, error?.message);
      }
    },
    async clearReminder() {
      try {
        const payload = {
          memberId: this.memberData?._id,
          courseId: this.courseId,
        };
        console.log(payload);
        this.$store.commit('toggleLoading', true);
        const response = await this.$store.dispatch('clearReminder', payload);
        this.handleGetMemberDetails();
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response?.message);
        await this.$store.dispatch('getPipelineDetails');
      } catch (error) {
        utils.setStatusMsg(this, error?.message);
      }
    },
  },
};
</script>
